import { computed } from 'vue'
import {
  useGolfI18nStore,
  GOLF_LANGUAGES,
  GolfLanguage,
} from '@/store/golf-i18n'

export const useGolfI18n = () => {
  const store = useGolfI18nStore()

  const t = (key: string, params?: Record<string, string | number>) => {
    return store.t(key, params)
  }

  const currentLanguage = computed(() => store.currentLanguage)
  const currentLanguageOption = computed(() => store.currentLanguageOption)

  const setLanguage = (lang: GolfLanguage) => {
    store.setLanguage(lang)
  }

  const fetchTranslations = () => {
    return store.fetchTranslations()
  }

  return {
    t,
    currentLanguage,
    currentLanguageOption,
    languages: GOLF_LANGUAGES,
    setLanguage,
    fetchTranslations,
    isLoading: computed(() => store.isLoading),
  }
}
